module.exports = __webpack_public_path__ + "img/banner_oae.64400d2.jpg";